var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 0H4.125C1.85075 0 0 1.91805 0 4.275V14.725C0 17.0819 1.85075 19 4.125 19H17.875C20.1493 19 22 17.0819 22 14.725V4.275C22 1.91805 20.1493 0 17.875 0ZM4.125 0.95H17.875C18.8687 0.95 19.7478 1.4307 20.3372 2.16885L13.2871 9.47625C12.6803 10.1042 11.8598 10.45 10.9982 10.45C10.1603 10.4339 9.32433 10.108 8.71383 9.47625L1.66283 2.16885C2.25225 1.4307 3.13042 0.95 4.125 0.95ZM21.0833 14.725C21.0833 16.5585 19.6442 18.05 17.875 18.05H4.125C2.35583 18.05 0.916667 16.5585 0.916667 14.725V4.275C0.916667 3.82185 1.00558 3.39055 1.16508 2.9963L8.06575 10.1479C8.84583 10.9564 9.88075 11.4 10.978 11.4C12.0752 11.4 13.1551 10.9564 13.9352 10.1479L20.8358 2.9963C20.9953 3.39055 21.0842 3.82185 21.0842 4.275L21.0833 14.725Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.fc14047bef44cbb59d2f164011440380.svg";
export { ForwardRef as ReactComponent };